<template>
  <div
    class="-scene-thumbnail"
    :class="{ v: isSelected }"
    @click="$_selectScene"
  >
    <template v-if="scene.src">
      <img :src="scene.src" alt="" />
      <div class="-duration" v-text="duration" />
      <div v-if="isSceneAtPlayhead" class="-playhead-marker"></div>
    </template>
    <div v-else class="-placeholder"></div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SceneDetectionThumbnail',

  props: {
    scene: { type: Object, required: true },
    isSelected: { type: Boolean, required: true },
    isSceneAtPlayhead: { type: Boolean, required: true },
  },

  data() {
    return {
      whenMounted: new _.ColdPromise(),
      duration: moment.utc(this.scene.duration * 1e3).format('m:ss'),
    };
  },

  watch: {
    isSelected: {
      immediate: true,
      handler() {
        this.whenMounted.then(() => {
          if (this.isSelected) {
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      },
    },
    isSceneAtPlayhead: {
      immediate: true,
      handler() {
        this.whenMounted.then(() => {
          if (this.isSceneAtPlayhead) {
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.whenMounted.resolve();
    });
  },

  methods: {
    $_selectScene() {
      this.$emit('selectScene', this.scene);
    },
  },
};
</script>

<style lang="scss" scoped>
.-scene-thumbnail {
  cursor: pointer;
  margin-right: 10px;
  padding-bottom: 0;
  position: relative;
  /*{{ so duration will remain hidden till image is taking space after load */
  display: inline-table;
  /*}}*/

  &.v {
    border: 2px solid $color-primary;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 4px solid white;
    }
  }

  .-duration {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 14px;
    line-height: 1;
    padding: 5px 6px;
    color: white;
    background-color: $color-position-normal;
  }

  .-playhead-marker {
    position: absolute;
    bottom: -7px;
    height: 2px;
    width: 100%;
    background-color: #c21447;
  }

  img {
    pointer-events: none;
  }

  .-placeholder {
    display: inline-block;
    vertical-align: middle;
    width: 97px;
    height: 54px;
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
